var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiVehicle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 84,
    viewBox: "0 0 86 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0477 31.3496C33.1083 32.4102 33.1083 34.1288 32.0477 35.1877C30.9871 36.2483 29.2685 36.2483 28.2095 35.1877C27.1489 34.1271 27.1489 32.4085 28.2095 31.3496C29.2702 30.2889 30.9888 30.2889 32.0477 31.3496",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1994 31.3495C14.26 32.4102 14.26 34.1288 13.1994 35.1877C12.1388 36.2483 10.4202 36.2483 9.36124 35.1877C8.30232 34.127 8.30061 32.4084 9.36124 31.3495C10.4219 30.2906 12.1388 30.2889 13.1994 31.3495",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1335 6.85376H23.9873C24.9331 6.85376 25.7008 7.62139 25.7008 8.56722V25.7018H3.42578",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56617 33.2685H5.13924C4.19341 33.2685 3.42578 32.5008 3.42578 31.555V22.2749",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6992 11.9941H33.1065C33.8073 11.9941 34.4379 12.4208 34.6966 13.0719L37.4484 19.9497C37.6095 20.3541 37.6934 20.7859 37.6934 21.2211V31.4128C37.6934 32.3586 36.9258 33.1263 35.98 33.1263H32.8426",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4125 33.2754H13.9961",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6937 23.9884H30.8398V17.1345H36.3229",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 6.8538H11.9931",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 11.9942H8.56617",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13924 17.1346H3.42578",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0477 74.1862C33.1083 75.2469 33.1083 76.9655 32.0477 78.0244C30.9871 79.085 29.2685 79.085 28.2095 78.0244C27.1489 76.9637 27.1489 75.2451 28.2095 74.1862C29.2702 73.1256 30.9888 73.1256 32.0477 74.1862",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1994 74.1862C14.26 75.2468 14.26 76.9654 13.1994 78.0243C12.1388 79.085 10.4202 79.085 9.36124 78.0243C8.30232 76.9637 8.30061 75.2451 9.36124 74.1862C10.4219 73.1273 12.1388 73.1256 13.1994 74.1862",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1335 49.6904H23.9873C24.9331 49.6904 25.7008 50.4581 25.7008 51.4039V68.5385H3.42578",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.56617 76.1051H5.13924C4.19341 76.1051 3.42578 75.3375 3.42578 74.3917V65.1116",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6992 54.8308H33.1065C33.8073 54.8308 34.4379 55.2575 34.6966 55.9086L37.4484 62.7864C37.6095 63.1908 37.6934 63.6226 37.6934 64.0578V74.2495C37.6934 75.1953 36.9258 75.9629 35.98 75.9629H32.8426",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4125 76.1121H13.9961",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6937 66.825H30.8398V59.9712H36.3229",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 49.6905H11.9931",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42578 54.8309H8.56617",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13924 59.9712H3.42578",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9227 31.3496C77.9833 32.4102 77.9833 34.1288 76.9227 35.1877C75.8621 36.2483 74.1435 36.2483 73.0845 35.1877C72.0239 34.1271 72.0239 32.4085 73.0845 31.3496C74.1452 30.2889 75.8638 30.2889 76.9227 31.3496",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0744 31.3495C59.135 32.4102 59.135 34.1288 58.0744 35.1877C57.0138 36.2483 55.2952 36.2483 54.2362 35.1877C53.1773 34.127 53.1756 32.4084 54.2362 31.3495C55.2969 30.2906 57.0138 30.2889 58.0744 31.3495",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0085 6.85376H68.8623C69.8081 6.85376 70.5758 7.62139 70.5758 8.56722V25.7018H48.3008",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4412 33.2685H50.0142C49.0684 33.2685 48.3008 32.5008 48.3008 31.555V22.2749",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5742 11.9941H77.9815C78.6823 11.9941 79.3129 12.4208 79.5716 13.0719L82.3234 19.9497C82.4845 20.3541 82.5684 20.7859 82.5684 21.2211V31.4128C82.5684 32.3586 81.8008 33.1263 80.855 33.1263H77.7176",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2875 33.2754H58.8711",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5687 23.9884H75.7148V17.1345H81.1979",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 6.8538H56.8681",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 11.9942H53.4412",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0142 17.1346H48.3008",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9227 74.1862C77.9833 75.2469 77.9833 76.9655 76.9227 78.0244C75.8621 79.085 74.1435 79.085 73.0845 78.0244C72.0239 76.9637 72.0239 75.2451 73.0845 74.1862C74.1452 73.1256 75.8638 73.1256 76.9227 74.1862",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0744 74.1862C59.135 75.2468 59.135 76.9654 58.0744 78.0243C57.0138 79.085 55.2952 79.085 54.2362 78.0243C53.1773 76.9637 53.1756 75.2451 54.2362 74.1862C55.2969 73.1273 57.0138 73.1256 58.0744 74.1862",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0085 49.6904H68.8623C69.8081 49.6904 70.5758 50.4581 70.5758 51.4039V68.5385H48.3008",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4412 76.1051H50.0142C49.0684 76.1051 48.3008 75.3375 48.3008 74.3917V65.1116",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5742 54.8308H77.9815C78.6823 54.8308 79.3129 55.2575 79.5716 55.9086L82.3234 62.7864C82.4845 63.1908 82.5684 63.6226 82.5684 64.0578V74.2495C82.5684 75.1953 81.8008 75.9629 80.855 75.9629H77.7176",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2875 76.1121H58.8711",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5687 66.825H75.7148V59.9712H81.1979",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 49.6905H56.8681",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3008 54.8309H53.4412",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0142 59.9712H48.3008",
    stroke: "#0B907B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiVehicle);
export default __webpack_public_path__ + "static/media/MultiVehicle.8720df52de83c9d563027b5f9cc7ac81.svg";
export { ForwardRef as ReactComponent };